import { WorkspaceFileTreeResponse, SearchWorkspaceResponse, WorkspaceFileContentResponse } from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

// Workspace API calls
export async function getWorkspaceFileTree(): Promise<WorkspaceFileTreeResponse> {
  const response = await fetch(`${getApiBaseUrl()}/workspace/file-tree`);
  return handleResponse<WorkspaceFileTreeResponse>(response);
}

export async function invalidateWorkspaceFileTreeCache(): Promise<void> {
  const response = await fetch(`${getApiBaseUrl()}/workspace/file-tree/invalidate`, {
    method: 'POST',
  });
  await handleResponse<void>(response);
}

export async function searchWorkspace(
  query: string,
  type: 'files' | 'folders' | 'all',
  page = 1,
  limit = 50,
): Promise<SearchWorkspaceResponse> {
  const params = new URLSearchParams({
    q: query,
    type,
    page: String(page),
    limit: String(limit),
  });
  const response = await fetch(`${getApiBaseUrl()}/workspace/search?${params.toString()}`);
  return handleResponse<SearchWorkspaceResponse>(response);
}


export async function getWorkspaceFileContent(filePath: string): Promise<WorkspaceFileContentResponse> {
  const response = await fetch(`${getApiBaseUrl()}/workspace/file-content?path=${encodeURIComponent(filePath)}`);
  return handleResponse<WorkspaceFileContentResponse>(response);
}